import filter from 'lodash/filter.js';
import map from 'lodash/map.js';
import identity from 'lodash/identity.js';
import startsWith from 'lodash/startsWith.js';

const delimiter = ':';

// Temporary Solution (TM) until TagType column/property is added to tags
export default ({ tags }, tagType, textTransform = identity) => {
  const query = textTransform(`${tagType}${delimiter}`);
  const matches = filter(tags, (tag) => startsWith(textTransform(tag), query));

  return map(matches, (match) => {
    const [, tagValue] = match.split(delimiter);

    return tagValue;
  });
};
